import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const broadBandFacts = Loadable(() => import('../../containers/web/index'));
export default MapTo('vcg/components/soe-home/react/broadBandFacts')(broadBandFacts);
